// Onay bilgisi localStorage'da tutulur: birinci taraf, "kesinlikle gerekli"
// kategorisinde ve her istekte sunucuya gönderilmez.
const STORAGE_KEY = 'ssi_cookie_consent';

// Çerez envanteri değişirse bu numarayı artırın; herkese yeniden sorulur.
const CONSENT_VERSION = 1;

export const CONSENT_ACCEPTED = 'accepted';
export const CONSENT_REJECTED = 'rejected';

export const getConsent = () => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;

    const parsed = JSON.parse(raw);

    if (parsed.version !== CONSENT_VERSION) return null;
    if (parsed.status !== CONSENT_ACCEPTED && parsed.status !== CONSENT_REJECTED) return null;

    // Karar süresiz geçerli: bir kez cevaplandıktan sonra banner bir daha
    // çıkmıyor. Yeniden sormak gerekirse CONSENT_VERSION artırılır.
    return parsed.status;
  } catch (error) {
    // Gizli sekmede localStorage erişimi hata fırlatabilir: onay yok say.
    return null;
  }
};

export const setConsent = (status) => {
  try {
    window.localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        status,
        version: CONSENT_VERSION,
        timestamp: new Date().toISOString(),
      })
    );
  } catch (error) {
    // Yazamıyorsak sessizce geç; banner her ziyarette tekrar görünür.
  }
};

export const clearConsent = () => {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    // Yok sayılabilir.
  }
};

export const hasAnalyticsConsent = () => getConsent() === CONSENT_ACCEPTED;
